export default "__VITE_ASSET__BmGZ4_iU__"